import { Language } from './Language';

export class English extends Language {
  public toIETF(): string {
    return 'en-US';
  }

  public toButtonText(): string {
    return 'English';
  }

  public isSelectedLanguage(i18nLang: string): boolean {
    return this.toIETF() === i18nLang || 'en-GB' === i18nLang;
  }
}
